import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: '1 Kaufen, 1 Gratis',
  [OFFER_TYPE.FREE_ITEM]: 'Gratisartikel',
  [OFFER_TYPE.AMOUNT_OFF]: 'Rabattbetrag',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Prozentualer Rabatt',
};
